import config from "@/config";
import axios from "axios";
import qs from 'qs'
import Vue from 'vue'
import router from "@/router";
import { Loading, Message } from "element-ui";

// 创建loading实例
var loading = null;
const vueIns = new Vue()
class HttpRequest {
  constructor() {
    this.baseUrl = config.BASE_URL;
    this.timeout = 1000000; // 1000s后超时
    console.log(config.BASE_URL);
  }


  setInterceptors(instance) {
    instance.interceptors.request.use(
      config => {
        loading = Loading.service({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
        // 可以增加token等属性
        // let pathname = location.pathname;
        // if(localStorage.getItem('token')){
        //     if(pathname != '/' && pathname != '/login'){
        //         config.headers.common['token'] = localStorage.getItem('token');
        //     }
        // }
        return config;
      },
      err => {
        return Promise.reject(err);
      }
    );

    instance.interceptors.response.use(
      res => {
        setTimeout(() => loading.close())
        if (res.headers['content-type'] && res.headers['content-type'].includes('application/vnd')) {
          loading.close();
          return Promise.resolve(res.data);
        } else if (res.status == 200) {
          // 接口请求成功，返回的结果都在data中
          const result = processingSuccessData(res.data);
          if (result) {
            const { code, data } = result;
            switch (code) {
              case 200:
                loading.close();
                return Promise.resolve(data);
              case 201:
                loading.close();
                Message(result.message);
                return Promise.reject(res.data);
              case 302:
              case 303:
                loading.close();
                Message(result.message);
                localStorage.removeItem('token');
                router.replace({ path: "/login" });
                return Promise.reject(res.data);
              default:
                loading.close();
                Message(result.message);
                return Promise.reject(res.data);
            }
          } else {
            loading.close();
            return Promise.reject(res);
          }
        } else {
          loading.close();
          return Promise.reject(res);
        }
      },
      err => {
        setTimeout(() => loading.close())
        Message(err);
        return Promise.reject(err.toJSON());
      }
    );
  }
  mergeOptions(options) {
    return {
      baseURL: this.baseUrl,
      timeout: this.timeout,
      ...options
    };
  }
  request(options) {
    const instance = axios.create(); // 每次请求都创建新的实例，方便每次请求都可单独配置
    this.setInterceptors(instance);
    const opts = this.mergeOptions(options);
    // console.log(JSON.stringify(opts.data));
    return instance(opts);
  }
  get(url, conf) {
    // 添加前置参数
    let prefixData = Object.create(null);
    prefixData = {
      appkey: config.APP_KEY
    };
    if (window.localStorage.getItem("token")) prefixData.token = window.localStorage.getItem("token")
    return this.request({
      method: "get",
      url,
      headers: {
        ...prefixData
      },
      params: {
        ...conf
      }
    });
  }
  get1(url, conf) {
    // 添加前置参数
    let prefixData = Object.create(null);
    prefixData = {
      appkey: config.APP_KEYT
    };
    if (window.localStorage.getItem("token")) prefixData.token = window.localStorage.getItem("token")
    return this.request({
      method: "get",
      url,
      headers: {
        ...prefixData
      },
      params: {
        ...conf
      }
    });
  }
  post(url, data, headers) {
    // 添加前置参数
    if (!headers) {
      headers = { "Content-Type": "application/x-www-form-urlencoded" };
    }
    let prefixData = Object.create(null);
    prefixData = {
      appkey: config.APP_KEY
    };
    if (window.localStorage.getItem("token")) prefixData.token = window.localStorage.getItem("token")
    return this.request({
      method: "post",
      url,
      headers: {
        ...headers,
        ...prefixData
      },
      data: qs.stringify(data)
    });
  }

  postGai(url, data, headers) {
    // 添加前置参数
    if (!headers) {
      headers = { "Content-Type": "application/json;charset=UTF-8" };
    }
    let prefixData = Object.create(null);
    prefixData = {
      appkey: config.APP_KEY
    };
    if (window.localStorage.getItem("token")) prefixData.token = window.localStorage.getItem("token")
    return this.request({
      method: "post",
      url,
      headers: {
        ...headers,
        ...prefixData
      },
      data: data
    });
  }

  postGai1(url, data, headers) {
    // 添加前置参数
    if (!headers) {
      headers = { "Content-Type": "application/json;charset=UTF-8" };
    }
    let prefixData = Object.create(null);
    prefixData = {
      appkey: config.APP_KEYT
    };
    if (window.localStorage.getItem("token")) prefixData.token = window.localStorage.getItem("token")
    return this.request({
      method: "post",
      url,
      headers: {
        ...headers,
        ...prefixData
      },
      data: data
    });
  }

  post1(url, data, headers) {
    // 添加前置参数
    if (!headers) {
      headers = { "Content-Type": "application/x-www-form-urlencoded" };
    }
    let prefixData = Object.create(null);
    prefixData = {
      appkey: config.APP_KEYT
    };
    if (window.localStorage.getItem("token")) prefixData.token = window.localStorage.getItem("token")
    return this.request({
      method: "post",
      url,
      headers: {
        ...headers,
        ...prefixData
      },
      data: qs.stringify(data)
    });
  }
}



function processingSuccessData(data) {
  const keys = Object.keys(data);
  const isBusiness = keys.includes("code");
  let result = null;
  if (isBusiness) {
    result = {
      code: data.code,
      data: data.data,
      message: data.message
    };
  }
  return result;
}

export default new HttpRequest();